<template>
    <transition name="modal" appear>
        <div class="modal" role="dialog" aria-modal="true" aria-labelledby="episode-modal-title">
            <header class="modal-header">              
                <div class="title">
                    <img :src="require('@/assets/images/website/zappelin-logo.png')" alt="Zappelin logo" />
                    <h1 id="episode-modal-title">De Boterhamshow</h1>
                </div> 
                <button class="close-button" aria-label="Sluiten" @click="closeModal">
                    <svg aria-hidden="true" height="24px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg>
                </button>
            </header>
            <div class="navigation">
                <div class="swiper-button-prev" role="button" aria-label="Vorige aflevering"></div>
                <div class="swiper-button-next" role="button" aria-label="Volgende aflevering"></div>
            </div>
            <swiper v-if="lastFiveEpisodes" :options="swiperOption">
                <swiper-slide v-for="(episode, index) in lastFiveEpisodes" :key="index">
                    <div v-if="episode.episodes[0]" class="episode">
                        <h2>{{episode.episodes[0].title}} {{dayName(episode.date)}}</h2>
                        <div class="episode-content episode-content--box-shadow">
                            <div class="watch-episode">
                                <div class="iframe-wrapper">
                                    <iframe
                                        class="iframe"
                                        :src="`https://player.ntr.nl/index.php?prid=${episode.episodes[0].prid}&showTitlebar=false`"
                                        :title="`Videospeler ${episode.episodes[0].title}`"
                                        :aria-label="`Videospeler ${episode.episodes[0].title}`"
                                        align="top"
                                        frameborder="0"
                                        marginheight="0"
                                        marginwidth="0"
                                        scrolling="no"
                                        allow="encrypted-media; geolocation; autoplay; fullscreen">
                                    </iframe>
                                </div>
                            </div>
                            <div class="play-episode">
                                <router-link :to="`/afleveringen/${stripEpisodeNumber(episode.episodes[0].name)}`">
                                    <img class="thumnbail" :src="require('@/assets/images/website/interactive-img' + (index + 1) + '.jpg')" :alt="`Thumbnail aflevering ${stripEpisodeNumber(episode.episodes[0].name)}`" />
                                    <div class="play-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.36 67.36"><g data-name="Layer 2"><rect width="67.36" height="67.36" rx="6.52" ry="6.52" fill="#7ebedd"/><path d="M46.45 19.43H21.24a3.06 3.06 0 0 0-3.06 3.05v25.21a3.07 3.07 0 0 0 3.06 3.06h25.21a3.06 3.06 0 0 0 3-3.06V22.48a3.06 3.06 0 0 0-3-3.05zM26.58 46.1a3.76 3.76 0 1 1 3.76-3.76 3.75 3.75 0 0 1-3.76 3.76zm7.26-7.26a3.76 3.76 0 1 1 3.76-3.75 3.76 3.76 0 0 1-3.76 3.75zm7.26-7.25a3.76 3.76 0 1 1 3.75-3.76 3.76 3.76 0 0 1-3.75 3.76z" fill="#fdfefe"/></g></svg>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="episode-content">
                            <div><h3>Bekijk de aflevering</h3></div>
                            <div><h3>Help Berny, speel mee!</h3></div>
                        </div>
                    </div> 
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex'
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import moment from 'moment'
    import { focusTrap } from '@/mixins/focusTrap'
    import { lockScroll, unlockScroll } from '@/utils/scrollLock'
	export default {
        components: {
          swiper,
          swiperSlide
        },
        mixins: [focusTrap],
        data() {
          return {
            swiperOption: {
            //   pagination: {
            //     el: '.swiper-pagination'
            //   },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              initialSlide: 4
            }
          }
        },
        mounted() {
            smarttag && smarttag('afleveringen')
            lockScroll()
        },

        beforeDestroy () {
            unlockScroll()
        },
        
        computed: {
            ...mapGetters([
                'lastFiveEpisodes'
            ])
        },

 		methods: {
             stripEpisodeNumber (value) {
                 return value.split('-')[1]
             },
             closeModal () {
                 this.$router.push('/')
             },
             dayName (value) {
                const now = moment()
                const yesterday = moment().subtract(1, "days")
                const daybeforeyesterday = moment().subtract(2, "days")

                if(value === now.format('YYYY-MM-DD'))
                    return '(vandaag)'

                if(value === yesterday.format('YYYY-MM-DD'))
                    return '(gisteren)'

                if(value === daybeforeyesterday.format('YYYY-MM-DD'))
                    return '(eergisteren)'
             }
 		}

 	}

 </script>

<style lang="scss" scoped>

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.modal {
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -35%;
    width: 70%;    
    height: auto;
    z-index: 3002;
    background-color: #d94556;
    transform: translateY(-50%);
    border-radius: 6px;
}
h1, h2, h3 {    
    font-family: 'bariol-bold';
    font-weight: normal;
}
h1 {
    font-size: 32px;
    margin: 0 0 0px 10px;
    line-height: 0;
}
h2 {
    font-size: 28px;
}
h3 {
    text-align: center;
    margin: 14px 0 0 0;
    font-size: 22px;
}
.modal-header {
    // background: white;    
    // text-align: right;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    background: white;
    padding: 20px;
    justify-content: space-between;
    align-items: center;
}
.title {
    display: flex;
    align-items: center;
    img {
        width: 100px;
        height: auto;
        margin-right: 15px;
    }
}
.iframe-wrapper {
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    background: black;
    @include aspect-ratio(16,9);
}
.iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.close-button {
    background: none;
    border: 0;
    outline: 0;
    cursor: pointer;
    padding: 20px 0 20px 10px;
    margin: 0;
}
.episode {
    padding: 30px 20px 30px 20px;
    h2 {        
        margin-top: 0;
        color: white;
        text-align: center;
        margin-bottom: 30px;
    }
}
.episode-content {
    display: flex;
    > div {
        width: 50%;
        border-radius: 10px;
        overflow: hidden;
        &:first-child {
            margin-right: 10px;
        }
        &:last-child {
            margin-left: 10px;
        }
    }

    &--box-shadow {
        > div {
            -webkit-box-shadow: 0 6px 1px rgba(5,21,34,0.29);
            box-shadow: 0 6px 1px rgba(5,21,34,0.29);
        }
    }

}
.play-episode a {
    position: relative;
    display: block;
}
.play-icon {
    padding: 10px;
    background: white;
    border-top-right-radius: 10px;
    width: 40px;
    position: absolute;
    left: 0;
    bottom: 0;
    svg {
        display: block;
        width: 40px;
        height: 40px;
    }
}
.thumnbail {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    @include aspect-ratio(16,9);
    max-width: 100%;
    height: auto;
    border-radius: 10px;
    display: block;
}
.modal-enter-active, .modal-leave-active {
  transition: opacity .3s, transform .5s;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
.swiper-button-next,
.swiper-button-prev {
    position: static;
    background: none;
    width: 26px;
    height: 26px;
    background: blue;
    margin: 0;
    
}
.swiper-button-next {
    background: url('~@/assets/images/website/swiper-next.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.swiper-button-prev {
    background: url('~@/assets/images/website/swiper-prev.png');
    background-size: contain;
    background-repeat: no-repeat;
}
.swiper-button-next.swiper-button-disabled,
.swiper-button-prev.swiper-button-disabled,
.swiper-button-disabled {
    opacity: 0;
}
.navigation {
    position: absolute;
    padding: 20px 20px 0 20px;
    display: flex;
    width: calc(100% - 40px);
    top: 126px;
    justify-content: space-between;
}
 </style>


// WEBPACK FOOTER //
// EpisodeModal.vue?3b1a0432